import type { FormChatFieldInput } from "gsintegrations";

const REVIEW_CONTROL_REPLIES = ["Confirmar", "Editar campos"];

/**
 * The chat shell paints chips from the `quickReplies` prop. A `quick_replies`
 * field input keeps its own list, and that list is what the step actually
 * offers when the top-level array is empty.
 */
export const resolveDisplayedQuickReplies = (
  quickReplies: string[],
  fieldInput: FormChatFieldInput | undefined,
): string[] => {
  const fieldReplies =
    fieldInput?.type === "quick_replies"
      ? (fieldInput.quickReplies ?? []).filter(Boolean)
      : [];
  const source = fieldReplies.length > 0 ? fieldReplies : quickReplies;
  return source.filter((reply: string) => !REVIEW_CONTROL_REPLIES.includes(reply));
};
